import React, { useState } from 'react';
import clsx from 'clsx';
import * as Collapsible from '@radix-ui/react-collapsible';

import { IProps, IFeatureVideoWidget } from './FeatureVideoBlock.interface';
import './FeatureVideoBlock.styles.css';

import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper from '@/layouts/ContentWrapper/ContentWrapper.component';
import { ContentColumn } from '@/layouts/ContentWrapper/ContentWrapper.component';
import Heading from '@/elements/Heading/Heading.component';
import Video from '@/elements/Video/Video.component';
import Text from '@/elements/Text/Text.component';
import Button from '@/elements/Button/Button.component';

export const FeatureVideoWidget = (props: IFeatureVideoWidget) => {
    const {
        video,
        description,
        transcript,
        transcriptButtonText,
        transcriptButtonTextOpen,
    } = props;
    const [open, setOpen] = useState(false);

    return (
        <>
            {video?.url && <Video {...video} className="featureVideoBlock__video" />}
            <Collapsible.Root
                open={open}
                onOpenChange={setOpen}
                className="featureVideoBlock__collapsible"
            >
                <div className="featureVideoBlock__content">
                    {description && (
                        <Text
                            className="featureVideoBlock__description"
                            html={description}
                        />
                    )}
                    {transcript && (
                        <Collapsible.Trigger asChild>
                            <Button
                                className="featureVideoBlock__transcriptTrigger"
                                aria-expanded={open}
                                as="button"
                            >
                                {open ? transcriptButtonTextOpen : transcriptButtonText}
                            </Button>
                        </Collapsible.Trigger>
                    )}
                </div>
                {transcript && (
                    <Collapsible.Content className="featureVideoBlock__transcriptContent">
                        <Text html={transcript} />
                    </Collapsible.Content>
                )}
            </Collapsible.Root>
        </>
    );
};

const FeatureVideoBlock: React.FC<IProps> = (props) => {
    const {
        className,
        heading,
        video,
        description,
        transcript,
        transcriptButtonText = 'Show Transcript',
        transcriptButtonTextOpen = 'Hide Transcript',
        ...blockWrapperProps
    } = props;

    return (
        <BlockWrapper
            className={clsx('featureVideoBlock', className)}
            {...blockWrapperProps}
        >
            <ContentWrapper>
                <ContentColumn layout="default">
                    {heading ? <Heading level={2} html={heading} /> : null}
                    {video?.url ? <FeatureVideoWidget {...props} /> : null}
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};

export { FeatureVideoBlock };
